import { connectShadedLoadable } from 'helpers/loadableHelpers'
import { Guards } from 'interfaces/guards'
import { createSelector } from 'reselect'
import { networthSummaryAppSelector, networthSummaryDeltaSelector } from 'selectors/networthSelectors'
import NetworthDelta, { NetworthDeltaProps, NetworthDeltaStateProps } from 'components/features/pfm/NetworthDelta/NetworthDelta'
import { networthSummaryDeltaGuard } from 'guards/networthGuards'
import { connectOptionallyAdvanced, createPositiveRendererProps, NO_RENDER, OptionalRendererProps } from 'tangle-shared'
import { State } from 'interfaces/state'
import { NETWORTH_SUMMARY_TIMEFRAMES, NETWORTH_SUMMARY_TIMEFRAMES_MAP } from 'constants/networth'
import { NetworthSummaryTimeframe } from 'interfaces/networth'
import { setNetworthSummaryTimeframeActionCreator } from 'actions/networthActions'
import { StoreDispatch } from 'interfaces/component'

type NetworthDeltaContainerOptionalProps = {
  title: string | null
  value: string | null
  timeframe: NetworthSummaryTimeframe | null
}

const createMapStateToProps = () => createSelector(
  networthSummaryDeltaSelector,
  networthSummaryAppSelector,
  (
    value,
    { timeframe },
  ): NetworthDeltaContainerOptionalProps => {
    const title = timeframe
      ? NETWORTH_SUMMARY_TIMEFRAMES_MAP[timeframe].title
      : null

    return {
      title,
      value,
      timeframe,
    }
  },
)

const selectorFactory = (dispatch: StoreDispatch) =>
  (_nextState: State, nextOwnProps: NetworthDeltaContainerOptionalProps): OptionalRendererProps<NetworthDeltaProps> => {
    const {
      title,
      value,
      timeframe,
    } = nextOwnProps

    if (title === null || value === null || !timeframe) {
      return NO_RENDER()
    }

    const currentTimeframeIndex = NETWORTH_SUMMARY_TIMEFRAMES.indexOf(timeframe)
    const nextTimeframeIndex = currentTimeframeIndex >= NETWORTH_SUMMARY_TIMEFRAMES.length - 1
      ? 0
      : currentTimeframeIndex + 1
    const nextTimeframe = NETWORTH_SUMMARY_TIMEFRAMES[nextTimeframeIndex]

    const props = createPositiveRendererProps<NetworthDeltaProps>({
      title,
      value,
      onClick: () => dispatch(setNetworthSummaryTimeframeActionCreator(nextTimeframe)),
    })

    return props
  }

const guards: Guards = [
  networthSummaryDeltaGuard,
]

const NetworthDeltaContainerOptional = connectOptionallyAdvanced<
  NetworthDeltaStateProps, {}, State
  >(selectorFactory)(NetworthDelta)

const NetworthDeltaContainer = connectShadedLoadable<
  // TODO
  {}, {}, {}, {}
  >(createMapStateToProps, undefined, guards)(NetworthDeltaContainerOptional)

export default NetworthDeltaContainer
